module.exports = __webpack_public_path__ + "img/demokasa.vestok.hr.75e704c5.png";